import * as bootstrap from 'bootstrap';

import { bookerGet, bookerPost, bookerPut, bookerDelete } from './bookerFetch.js';
import { showToast } from './toast.js';
import { initEventCreationDatepicker, initEventEditDatepicker } from './datepicker.js';
import { accountBalanceUpdateAnimation } from './ui.js'; 
import { parseFlatpickrDate } from './utils.js';

let currentSearchDate = new Date();
let previousBalance = 0;
let previousExpectedBalance = 0;

const onDatepickerMonthChange = function (selectedDate) {
    const monthChanged = selectedDate.getMonth() !== currentSearchDate.getMonth()
        || selectedDate.getFullYear() !== currentSearchDate.getFullYear();
    currentSearchDate = selectedDate;
    if (monthChanged) reloadAccountEventsTable();
};


async function reloadAccountEventsTable() {

    const accountId = document.querySelector('[data-js-field="bankAccountId"]')?.value;

    const currentCounter = document.querySelector('[data-js-field="currentBalance"]');
    const expectedCounter = document.querySelector('[data-js-field="expectedBalance"]');

    if (currentCounter && expectedCounter) {
        previousBalance = currentCounter.dataset.currentValue;
        previousExpectedBalance = expectedCounter.dataset.currentValue;

        const params = new URLSearchParams({
            accountId,
            searchDate: currentSearchDate.toDateString()
        });

        const { status, text } = await bookerGet(
            `/BookerAppUser/AccountEvent/GetAccountEvents?${params}`
        );

        if (status !== 200 || text === null) return;

        const table = document.querySelector('#accountEventsTable');
        const tableDiv = document.querySelector('#accountPeriodActivityDiv');

        table.style.opacity = '0';

        setTimeout(() => {
            tableDiv.innerHTML = text;
            currentCounter.dataset.previousValue = previousBalance;
            expectedCounter.dataset.previousValue = previousExpectedBalance;

            table.style.opacity = '1';
            accountBalanceUpdateAnimation();
        }, 250);
    }

   

}

 function initCreateAccountEventHandler() {
    const newEventDiv = document.querySelector('#newAccountEventDiv');
    if (!newEventDiv) return;

    newEventDiv.addEventListener('submit', async function (e) {
        if (!e.target.matches('#newAccountEventForm')) return;
        e.preventDefault();
        const isRecurrent = document.querySelector('[data-js-field="eventFrequencyId"]').value != 0;
        const endPoint = isRecurrent
            ? '/BookerAppUser/Recurrence/Create'
            : '/BookerAppUser/AccountEvent/Create';

        const form = document.querySelector('#newAccountEventForm');

        const { status, text } = await bookerPost(endPoint, new FormData(form));

        if (status === 200) {
            reloadAccountEventsTable();
            resetEventCreationForm('newAccountEventForm');
        }
        if (status === 400 && text !== null) {
            newEventDiv.innerHTML = text;
            initEventCreationDatepicker(onDatepickerMonthChange);
            $.validator.unobtrusive.parse(newEventDiv);
        } 
    })
}

function resetEventCreationForm(formId) {
    document.querySelectorAll(`#${formId} input.resetable`)
        .forEach(input => input.value = '');

    document.querySelectorAll(`#${formId} span.resetable`)
        .forEach(span => span.textContent = '');
}

function initIsPermanentCheckBoxHandler() {
    document.querySelector('#newAccountEventDiv')
        ?.addEventListener('click', function (e) {
            const checkbox = e.target.closest('[data-js-field="isPermanent"]');
            if (!checkbox) return;

            const isChecked = checkbox.checked;
            checkbox.value = isChecked;

            const occurrencesCount = document.querySelector('[data-js-field="occurrencesCount"]');
            if (!occurrencesCount) return;

            occurrencesCount.value = '';
            occurrencesCount.placeholder = isChecked ? "Sans objet" : "Indiquez un nombre d'occurences";
            occurrencesCount.disabled = isChecked;

            const validationError = occurrencesCount.parentElement
                .querySelector('field-validation-error');
            if (validationError) validationError.style.display = isChecked ? 'none' : '';

        });
}

function initEventFrequencyChangeHandler() {
    document.querySelector('#newAccountEventDiv')
        ?.addEventListener('change', function (e) {
            const select = e.target.closest('[data-js-field="eventFrequencyId"]');
            if (!select) return;

            const isRecurrent = select.value != 0;

            const checkbox = document.querySelector('[data-js-field="isPermanent"]');
            if (!checkbox) return;
            if(!isRecurrent) checkbox.checked = false;
            checkbox.disabled = !isRecurrent;
            const isPermanent = checkbox.checked;

            const occurrencesCount = document.querySelector('[data-js-field="occurrencesCount"]');
            if (occurrencesCount) {
                occurrencesCount.value = '';
                occurrencesCount.placeholder = isRecurrent
                    ? isPermanent
                    ? "Sans objet"
                    : "Indiquez un nombre d'occurences"
                    : "Sans objet";
                occurrencesCount.disabled = !isRecurrent || isPermanent;
            }
        })
}

function initEventCreationDatepickerChangeHandler() {
    document.querySelector('#newAccountEventDiv')
        ?.addEventListener('change', function (e) {
            const picker = e.target.closest('[data-js-field="eventCreationDate"]');
            if (!picker) return;

            const selectedDate = picker._flatpickr?.selectedDates[0];
            if (!selectedDate) return;

            const monthChanged = selectedDate.getMonth() !== currentSearchDate.getMonth()
                || selectedDate.getFullYear() !== currentSearchDate.getFullYear();

            currentSearchDate = selectedDate;

            if (monthChanged) reloadAccountEventsTable();
                
        })
}

 function initAccountEventTableHandlers() {
    const tableDiv = document.querySelector('#accountPeriodActivityDiv');
    if (!tableDiv) return;

    tableDiv.addEventListener('click', async function (e) {
        //Suppression d'évènement ponctuel
        const removeBtn = e.target.closest('.accountEventRemoveBtn');
        if (removeBtn) {
            const accountId = document.querySelector('[data-js-field="bankAccountId"]').value;
            const eventDate = document.querySelector('[data-js-field="eventCreationDate"]').value;
            const accountEventId = removeBtn.dataset.accounteventid;

            const params = new URLSearchParams({
                accountId,
                accountEventId,
                eventDate
            });
            const { status } = await bookerDelete(
                `/BookerAppUser/AccountEvent/Remove?${params}`
            );

            if (status === 200) {
                await reloadAccountEventsTable();
                showToast('success', "L'évènement a été supprimé.");
            }
            return;
        }

        //Ouverture modal suppression évènement récurrent
        const deletePlannedBtn = e.target.closest('.accountPlannedEventDeleteBtn');
        if (deletePlannedBtn) {
            const confirmBtn = document.querySelector('#deletePlannedEventBtn');
            confirmBtn.dataset.accountEventId = deletePlannedBtn.dataset.accountEventId;
            confirmBtn.dataset.recurrenceId = deletePlannedBtn.dataset.recurrenceId;
            bootstrap.Modal.getOrCreateInstance(
                document.querySelector('#accountPlannedEventSuppressionModal')
            ).toggle();
            return;
        }

        //Ouverture modal édition
        const editBtn = e.target.closest('.accountEventEditBtn');
        if (editBtn) {
            const id = editBtn.value;
            const { status, text } = await bookerGet(
                `/BookerAppUser/AccountEvent/Edit?id=${id}`
            );

            if (status === 200 && text !== null) {
                const modalBody = document.querySelector('#accountEventEditModal .modal-body')
                modalBody.innerHTML = '';
                modalBody.innerHTML = text;

                const dateInput = document.querySelector('[data-js-field="eventUpdateDate"]');
                const date = parseFlatpickrDate(dateInput?.value);

                const minDate = date ? new Date(date.getFullYear(), date.getMonth(), 1) : null;
                const maxDate = date ? new Date(date.getFullYear(), date.getMonth() + 1, 0) : null;

                initEventEditDatepicker(minDate, maxDate);
                $.validator.unobtrusive.parse(modalBody);
                bootstrap.Modal.getOrCreateInstance(
                    document.querySelector('#accountEventEditModal')
                ).toggle();
            }
            return;
        }
    });
}

 function initEditAccountEventHandler() {
     const editModal = document.querySelector('#accountEventEditModal');
    if (!editModal) return;

     editModal.addEventListener('submit', async function (e) {
        if (!e.target.matches('#accountEventEditForm')) return;
        e.preventDefault();
        const recurrenceId = document.querySelector('[data-js-field="recurrenceId"]')?.value;
        const endPoint = recurrenceId
            ? '/BookerAppUser/Recurrence/Update'
            : '/BookerAppUser/AccountEvent/Edit';
        const form = document.querySelector("#accountEventEditForm");
        const { status, text } = await bookerPost(endPoint, new FormData(form));

        if (status === 200) {
            await reloadAccountEventsTable();
            bootstrap.Modal.getOrCreateInstance(
                document.querySelector('#accountEventEditModal')
            ).hide();
        }
         if (status === 400 && text !== null) {
             const modalBody = document.querySelector('#accountEventEditModal .modal-body');
             modalBody.innerHTML = '';
             modalBody.innerHTML = text;
             const dateInput = document.querySelector('[data-js-field="eventUpdateDate"]');
             const date = parseFlatpickrDate(dateInput?.value);
             const minDate = date ? new Date(date.getFullYear(), date.getMonth(), 1) : null;
             const maxDate = date ? new Date(date.getFullYear(), date.getMonth() + 1, 0) : null;
             $.validator.unobtrusive.parse(modalBody);
             initEventEditDatepicker(minDate, maxDate);
        }
    })
}

 function initDeletePlannedEventHandler() {
    document.querySelector('#deletePlannedEventBtn')
        ?.addEventListener('click', async function () {
            const cancelFromGivenEvent = document.querySelector('.deleteOption:checked')?.value === 'false';

            const formData = new FormData();
            formData.append('recurrenceId', this.dataset.recurrenceId);
            if (cancelFromGivenEvent) {
                formData.append('accountEventId', this.dataset.accountEventId);
            }

            const { status } = await bookerPut(
                '/BookerAppUser/Recurrence/CancelRecurrence', formData
            );

            bootstrap.Modal.getOrCreateInstance(
                document.querySelector('#accountPlannedEventSuppressionModal')
            ).hide();

            if (status === 200) {
                await reloadAccountEventsTable();
                const message = cancelFromGivenEvent ? "Tous les évènements ont été supprimés." : "L'évènement a été supprimé.";
                showToast('success', message);
            }
        });
}

function init() {
    previousBalance = parseFloat(
        document.querySelector('[data-js-field="currentBalance"]')?.dataset.currentValue) || 0;

    previousExpectedBalance = parseFloat(
        document.querySelector('[data-js-field="expectedBalance"]')?.dataset.currentValue) || 0;

    initEventCreationDatepicker(onDatepickerMonthChange);
    initCreateAccountEventHandler();
    initIsPermanentCheckBoxHandler();
    initEventFrequencyChangeHandler();
    initEventCreationDatepickerChangeHandler();
    initAccountEventTableHandlers();
    initEditAccountEventHandler();
    initDeletePlannedEventHandler();
    accountBalanceUpdateAnimation();

}

export { init };